import { useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { CheckCircle2, Loader2 } from "lucide-react";
import { formatApiErrorDetail } from "@/lib/api";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

export default function AppReset() {
  const { appId } = useParams();
  const [params] = useSearchParams();
  const [password, setPassword] = useState("");
  const [state, setState] = useState({ busy: false, error: "", done: false });

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 8) return setState({ ...state, error: "Use at least 8 characters" });
    setState({ busy: true, error: "", done: false });
    const r = await fetch(`${BACKEND}/api/apps/${appId}/auth/reset`, {
      method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ token: params.get("token") || "", password }),
    }).catch(() => null);
    const j = r ? await r.json().catch(() => ({})) : {};
    setState(r?.ok ? { busy: false, error: "", done: true } : { busy: false, done: false, error: formatApiErrorDetail(j.detail?.message || j.detail) || "Could not reset — try again" });
  };

  return (
    <main data-testid="app-reset-page" className="noise grid min-h-screen place-items-center bg-[#07090E] px-5">
      <form onSubmit={submit} className="card-tech w-full max-w-sm space-y-4 rounded-2xl p-6">
        <p className="font-mono-tech text-xs uppercase tracking-widest text-cyan-400">// account</p>
        <h1 className="text-2xl font-bold text-white">Choose a new password</h1>
        {state.done ? (
          <p data-testid="app-reset-success" className="flex items-start gap-2 text-sm text-emerald-300"><CheckCircle2 className="mt-0.5 h-4 w-4 shrink-0" /> Your password has been updated. You can close this page and log in.</p>
        ) : (
          <>
            <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="New password (8+ characters)" data-testid="app-reset-password-input"
              className="w-full rounded-lg border border-white/10 bg-[#07090E] px-3 py-2.5 text-sm text-white outline-none focus:border-cyan-400/60" />
            {state.error && <p data-testid="app-reset-error" className="text-sm text-red-400">{state.error}</p>}
            <button type="submit" disabled={state.busy} data-testid="app-reset-submit" className="btn-glow inline-flex w-full items-center justify-center gap-2 rounded-full bg-cyan-400 px-5 py-2.5 text-sm font-semibold text-[#07090E] hover:bg-cyan-300 disabled:opacity-60">
              {state.busy && <Loader2 className="h-4 w-4 animate-spin" />} Save password
            </button>
          </>
        )}
      </form>
    </main>
  );
}
